// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b147e092","826":"3c04a2c3","903":"31832658"}[chunkId] + ".chunk.js";
};